import type { IndividualPaymentPersonCourseViewModel } from '@/shared/api/generated';

/**
 * Rótulo de um plano de pagamento no seletor da consolidação.
 *
 * O formato do protótipo é `FC222 — MBA em Finanças e Controladoria EaD`:
 * `description` (o código da turma) e `courseName`. Os dois são anuláveis no
 * `IndividualPaymentPersonCourseViewModel`, então cada ausência degrada para o
 * que sobrou — e, se nada sobrar, para o id do contrato. Um rótulo vazio
 * deixaria a opção invisível no dropdown, sem o operador entender por quê.
 *
 * @param plan - Contrato financeiro do aluno.
 * @param fallback - Rótulo de último caso, já interpolado com o id (ex.: `#101`).
 * @returns O rótulo a exibir na opção do seletor.
 *
 * @example
 * ```ts
 * formatPlanLabel({ description: 'FC222', courseName: 'MBA' }, '#101'); // 'FC222 — MBA'
 * formatPlanLabel({ courseName: 'MBA' }, '#101');                       // 'MBA'
 * formatPlanLabel({}, '#101');                                          // '#101'
 * ```
 */
export function formatPlanLabel(
  plan: IndividualPaymentPersonCourseViewModel,
  fallback: string,
): string {
  const parts = [plan.description, plan.courseName].filter(
    (part): part is string => typeof part === 'string' && part.trim().length > 0,
  );

  return parts.length > 0 ? parts.join(' — ') : fallback;
}
